

import {
  isRouteErrorResponse,
  Outlet,
  useNavigation,
} from "react-router";

import { useState, useEffect, useRef } from 'react';
import * as React from 'react';
import ReactDOM from "react-dom/client";
import { Button } from '@headlessui/react'
import { ArrowRightIcon } from '@heroicons/react/24/outline'
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider, AuthenticatedTemplate, useMsal, UnauthenticatedTemplate } from '@azure/msal-react';
import { msalConfig, loginRequest } from './authConfig';
import { useOnlineStatus } from './connectivityService';

const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  //   // Account selection logic is app dependent. Adjust as needed for different use cases.
  //   msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0]);
}

const userDefault = {
  name: 'Unknown',
  email: 'Unknown'
}
const nav = [
  { name: 'Home', href: '/', current: true },
  { name: 'Customers', href: 'customers', current: false },
  { name: 'Site Visits', href: 'sitevisits', current: false },
  { name: 'Shipments', href: 'shipments', current: false },
  { name: 'Setup', href: 'setup', current: false },
]
const userNavigation = [
  { name: 'Your Profile', href: '#' },
  { name: 'Settings', href: '#' },
  { name: 'Sign out', href: '#' },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}


export function Application() {
  return (
    <MsalProvider instance={msalInstance}>
      <DX></DX>
    </MsalProvider>
  );
}

export function DX() {
  const { instance } = useMsal();
  const msalActiveAccount = instance.getActiveAccount();
  const [navigationPages, setNavigationPages] = useState(nav);
  const [currentPage, setCurrentPage] = useState('Home');
  const [activeAccount, setActiveAccount] = useState(msalActiveAccount);
  const [user, setUser] = useState(userDefault)

  function getNav() {    
    return nav;
  }

  function updateMenu(name) {
    setCurrentPage(name);
    updateCurrentPage(name);
    setNavigationPages(nav);
  }

  function updateCurrentPage(name) {
    nav.forEach((it) => it.current = false);
    let page = nav.find((it) => it.name == name);
    page.current = true;
  }

  useEffect(() => {
    instance.handleRedirectPromise()
      .then(() => {   
      })
      .catch((err) => {
        console.error("MSAL redirect error", err);
      });
  }, [instance]);

  useEffect(() => {
    updateMenu("Home");
  }, []);

  useEffect(() => {
    if (activeAccount) {
      setUser(
        {
          name: activeAccount.name,
          email: activeAccount.username
        }
      )
    }
  }, [activeAccount]);

  instance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const account = event.payload.account;
      setActiveAccount(account);
    }
  });

  return (
    <div className="relative h-screen bg-black">
      <AuthenticatedTemplate>
        {activeAccount ? (
          <>
            <Outlet context={{ activeAccount, instance }} />
          </>
        ) : null}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <><Activate instance={instance}></Activate></>
      </UnauthenticatedTemplate>
    </div>
  )
}

function Activate({ instance }) {

  const isOnline = useOnlineStatus();

  const handleRedirect = () => {
    instance
      .loginRedirect({
        ...loginRequest,
        prompt: 'create',
      })
      .catch((error) => console.log(error));
  };

  return (
    <div className="h-screen min-w-full overflow-hidden bg-black font-pin relative">
      <div className="absolute top-0 right-0 p-6">
        <img
          alt="Yellow"
          src="/yellow.svg"
          className=""
        />
      </div>

      {isOnline &&
        <>
          <div className="absolute -right-16 w-32 h-32 bg-pvs-gray rotate-45 rounded-lg top-1/2 "></div>
          <div onClick={handleRedirect} className="absolute -right-16 w-32 h-32 top-1/2 flex items-center justify-center ">
            <ArrowRightIcon className="h-8 pr-12 bold" ></ArrowRightIcon>
          </div>
        </>
      }

      <div className="flex items-center h-full">
        <div className="grid grid-cols-6 gap-4 pl-4">
          <div className="col-span-5 bg-white col-start-2">
            <img
              alt="PVS"
              src="/truck.svg"
              className="min-w-full bg-black"
            />
          </div>
          <div className="col-span-2">
            <img
              alt="PVS"
              src="/logo.svg"
              className="min-w-5/6  p-5 bg-black"
            />
          </div>
          <div className="col-span-5 pl-4">
            <span className="text-5xl font-inter">
              Driver
              Operations &
              Order
              Schedule
            </span>
          </div>

          <div className="col-span-5 col-start-1 bg-black">
            {isOnline &&
              <Button className="w-full bg-pvs-gray block rounded p-3.5 items-center justify-center text-white mt-2 mb-16 disabled:text-pvsred" onClick={handleRedirect}>Activate Device</Button>
            }
            {!isOnline &&
              <div className="text-pvsred">Seems you are offline, coonnectivity is required to activate the device.</div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default function App() {
  const navigation = useNavigation();
  return (
    <>
      <Outlet />
    </>
  );
}

export function ErrorBoundary({ error }) {
  let message = "Oops!";
  let details = "An unexpected error occurred.";
  let stack;

  if (isRouteErrorResponse(error)) {
    message = error.status === 404 ? "404" : "Error";
    details =
      error.status === 404
        ? "The requested page could not be found."
        : error.statusText || details;
  } else if (import.meta.env.DEV && error && error instanceof Error) {
    details = error.message;
    stack = error.stack;
  }

  return (
    <main className="pt-16 p-4 container mx-auto">
      <h1>{message}</h1>
      <p>{details}</p>
      {stack && (
        <pre className="w-full p-4 overflow-x-auto">
          <code>{stack}</code>
        </pre>
      )}
    </main>
  );
}
